/* eslint-disable no-nested-ternary */
/** @jsxImportSource @emotion/react */

import React, {useMemo} from 'react';

import {css} from '@emotion/react';
import PropTypes from 'prop-types';

import ListArrow from '@/assets/icons/ListArrow.svg';
import WifiLowIcon from '@/assets/icons/WifiLow.svg';
import WifiMediumIcon from '@/assets/icons/WifiMedium.svg';
import WifiStrongIcon from '@/assets/icons/WifiStrong.svg';
import {fontSize, proteinConcentrationUnactiveColor, roundCorner} from '@/constants/appStyle';
import {FONT_SIZE as FontSize} from '@/constants/pcConstAppData';
import {WIFI_STRENGTH} from '@/contexts/WifiListContext';
import {useChangeWifiSettingContext, useWifiSettingContext} from '@/contexts/WifiSettingContext';

function WifiItem(props) {
  const {wifi, isSelected} = props;
  const {isConnecting} = useWifiSettingContext();
  const {SetSelectedWifi} = useChangeWifiSettingContext();

  const isConnectingWithCurrentWifi = useMemo(() => isConnecting && isConnecting.Name === wifi.Name, [isConnecting]);

  const wifiIcon =
    // eslint-disable-next-line no-nested-ternary
    wifi.Strength === WIFI_STRENGTH.LOW
      ? WifiLowIcon
      : wifi.Strength === WIFI_STRENGTH.MEDIUM
      ? WifiMediumIcon
      : WifiStrongIcon;

  const WifiItemStyle = css({
    width: 'inherit',
    backgroundColor: 'white',
    fontSize: parseInt(window.localStorage.getItem(FontSize), 10) || fontSize,
    textAlign: 'left',
    padding: '10px',
    display: 'flex',
    border: isSelected ? `2px solid ${proteinConcentrationUnactiveColor}` : 'none',
    borderRadius: roundCorner,
  });

  const WifiNameStyle = css({
    paddingLeft: '12px',
    width: '100%',
    minWidth: '100px',
    justifyContent: 'flex-start',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  });

  const StatusStyle = css({
    width: '200px',
    color: !wifi.IsConnected && isConnectingWithCurrentWifi ? 'grey' : 'green',
  });

  const WifiArroStyle = css({
    float: 'left',
  });

  return (
    <div
      css={WifiItemStyle}
      onClick={() => SetSelectedWifi(wifi)}
    >
      <img
        src={wifiIcon}
        alt={wifiIcon}
      />
      <div css={WifiNameStyle}>{wifi.Name}</div>
      {!wifi.IsConnected && isConnectingWithCurrentWifi ? (
        <div css={StatusStyle}>Connecting...</div>
      ) : wifi.IsConnected && isConnecting === null ? (
        <div css={StatusStyle}>Connected</div>
      ) : (
        <img
          css={WifiArroStyle}
          src={ListArrow}
          alt={ListArrow}
        />
      )}
    </div>
  );
}
WifiItem.propTypes = {
  isSelected: PropTypes.bool,
  wifi: PropTypes.shape({
    Name: PropTypes.string,
    Strength: PropTypes.oneOf([WIFI_STRENGTH.LOW, WIFI_STRENGTH.MEDIUM, WIFI_STRENGTH.STRONG]),
    IsConnected: PropTypes.bool,
  }),
};
WifiItem.defaultProps = {
  isSelected: false,
  wifi: {},
};
export default React.memo(WifiItem);
